import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Typography from '@mui/material/Typography';


const steps = [
  {
    label: 'Setup scenario',
    description: `This tool can quantify cascading losses on infrastructure systems due to hazards. 
    Write your scenario label and hazard name to begin.`,
  },
  {
    label: 'Identify exposed infrastructures',
    description:
      'Upload your spatial hazard data and run analysis to identify infrastructures directly exposed. Accepted file formats: tif, geojson, shp.',
  },
  {
    label: 'Quantify cascading impacts',
    description: `Run quantification analysis to estimate indirect impacts such as the number of population affected and key infrastructures.`,
  },
];

export default function VerticalLinearStepper({ activeStep }) {
  return (
    <Box sx={{ maxWidth: 300 }}>
      <Stepper 
          activeStep={activeStep} 
          orientation="vertical"
          sx={{
            "& .MuiStep-root": { background: "transparent", boxShadow: "none" },
            "& .MuiStepConnector-line": { display: "none" },
          }}
        >
        {steps.map((step, index) => (
          <Step key={step.label} completed={index < activeStep}>
            <StepLabel>
              <Typography>{step.label}</Typography>
            </StepLabel>
            <StepContent>
            <Typography>{step.description}</Typography>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}